import { convertFromRaw, convertToRaw, EditorState } from "draft-js"
import { plural_entity_reference_revisions_paragraph_with_target_node_event_field_paragraphs_parser } from "../api/drupal/parser"
import { Text as TextProps } from "../backendApi/generated"
import { features } from "../features"
import draftToHtml = require("draftjs-to-html");
import React = require("react");
import MarkdownIt = require('markdown-it')

export { TextProps }

export const Text = (props: TextProps) => {
  if (!props) return <></>
  switch (props.MarkUp) {
    case 'plaintext': return PlainText(props.Content)
    case 'html': return HTML(props.Content)
    case 'draftjs': return DraftJS(props.Content)
    case 'blocks': return Blocks(props.Content)
    case 'markdown': return Markdown(props.Content)
    default: throw new Error(`The markup type ${props.MarkUp} is not (yet) supported`)
  }
}

const PlainText = (text: string) => <div className="plaintext-block">{text}</div>

const HTML = (html: string) => <div
  className="richtext-block text--styled"
  dangerouslySetInnerHTML={{ __html: html }} />

const DraftJS = (draftJs: string) => <div
  className="richtext-block text--styled"
  dangerouslySetInnerHTML={{
    __html: draftToHtml(convertToRaw(EditorState.createWithContent(convertFromRaw(JSON.parse(draftJs))).getCurrentContent()))
  }} />

const Blocks = (rawParagraphs: string) => {
  const config = features().events
  if (config == 'off') return <></>
  const { Blocks } = config
  const obj = JSON.parse(rawParagraphs);
  const blocks = plural_entity_reference_revisions_paragraph_with_target_node_event_field_paragraphs_parser(obj)

  return <Blocks {...{blocks}} />
}

const md = MarkdownIt({
  html: true,
  linkify: true,
  typographer: true,
  breaks: true,
});

const Markdown = (markdown: string) => {

  // The Olifantenpaadje WYSIWYG editor somehow allows bold passages to end in a whitespace character,
  // which is not standard Markdown practice. This piece of regex cleans up these occurences.

  // Matches any phrase surrounded by two pairs of asterisks '**', where:
  const phraseWithAsterisks = /\*\*.*?\*\*/g
  // Given phraseWithAsterisks, replace any trailing whitespace before the last '**' with just '**'.
  const processed = markdown.replace(phraseWithAsterisks, (match) =>
    match.replace(/\s+\*\*$/, '**')
  )

  return <div className="text--styled" dangerouslySetInnerHTML={{ __html: md.render(processed)}} />
}
